import axios from "axios";

async function handleRequest(request) {
  try {
    const { data } = await request;
    if (data.error) throw data;
    return data;
  } catch (e) {
    throw Error(e?.response?.data?.message || e.message || "Unknown error");
  }
}

export function getMolecularMarkerByName(_, payload) {
  return handleRequest(
    axios.get("/marker/molecular-marker-by-name", { params: payload })
  );
}

export function createNewMarkerWithDraft(_, payload) {
  return handleRequest(axios.post("/marker/create-and-draft", payload));
}

export function getOligoHistoryByMarker(_, payload) {
  return handleRequest(
    axios.get("/marker/oligo-history-by-marker", { params: payload })
  );
}

export function saveDraft(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/save-draft", body, { params: params })
  );
}

export function finishOligo(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/finish-oligo", body, { params: params })
  );
}

export function discardOligo(_, { params }) {
  return handleRequest(
    axios.put("/marker/discard-oligo", {}, { params: params })
  );
}

export function addNewOligo(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/add-new-oligo", body, { params: params })
  );
}

export function addTagOligo(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/add-tag-oligo", body, { params: params })
  );
}

export function startSynthesis(_, { params }) {
  return handleRequest(
    axios.put("/marker/start-synthesis", {}, { params: params })
  );
}

export function endSynthesis(_, { params }) {
  return handleRequest(
    axios.put("/marker/end-synthesis", {}, { params: params })
  );
}

export function startValidations(_, { params }) {
  return handleRequest(
    axios.put("/marker/start-validations", {}, { params: params })
  );
}

export function createMolecularMarker(_, payload) {
  return handleRequest(axios.post("/marker/create-v2", payload));
}

export function updateMolecularMarker(_, { params, body }) {
  return handleRequest(axios.put("/marker/update", body, { params: params }));
}

export function addItemToResult(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/add-item-to-result", body, { params: params })
  );
}

export function removeItemToResult(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/remove-item-to-result", body, { params: params })
  );
}

export function inclusivitySetupDone(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/inclusivity-setup-done", body, { params: params })
  );
}

export function addInclusivityObservations(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/add-inclusivity-observations", body, {
      params: params,
    })
  );
}

export function uploadResultsInclusivity(_, payload) {
  return handleRequest(
    axios.put("/marker/upload-results-inclusivity-file", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    })
  );
}

export function cleanAllResultsInclusivity(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/clean-all-results-inclusivity", body, {
      params: params,
    })
  );
}

export function selectItemResultForPositiveControl(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/select-positive-control", body, { params: params })
  );
}

export function exclusivitySameGenusToOtherSpeciesSetupDone(
  _,
  { params, body }
) {
  return handleRequest(
    axios.put(
      "/marker/exclusivity-samegenus-to-otherspecies-setup-done",
      body,
      { params: params }
    )
  );
}

export function addExclusivitySameGenusToOtherSpeciesObservations(
  _,
  { params, body }
) {
  return handleRequest(
    axios.put(
      "/marker/add-exclusivity-samegenus-to-otherspecies-observations",
      body,
      { params: params }
    )
  );
}

export function uploadResultsExclusivitySameGenusToOtherSpecies(_, payload) {
  return handleRequest(
    axios.put(
      "/marker/upload-results-exclusivity-samegenus-to-otherspecies-file",
      payload,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    )
  );
}

export function cleanAllResultsExclusivitySameGenusToOtherSpecies(
  _,
  { params, body }
) {
  return handleRequest(
    axios.put(
      "/marker/clean-all-results-exclusivity-samegenus-to-otherspecies",
      body,
      { params: params }
    )
  );
}

export function exclusivityOtherGenusSetupDone(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/exclusivity-othergenus-setup-done", body, {
      params: params,
    })
  );
}

export function cleanAllResultsExclusivityOtherGenus(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/clean-all-results-exclusivity-othergenus", body, {
      params: params,
    })
  );
}

export function addExclusivityOtherGenusObservations(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/add-exclusivity-othergenus-observations", body, {
      params: params,
    })
  );
}

export function uploadResultsExclusivityOtherGenus(_, payload) {
  return handleRequest(
    axios.put("/marker/upload-results-exclusivity-othergenus-file", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    })
  );
}

export function cleanAllResultsSoilTest(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/clean-all-results-soil-test", body, {
      params: params,
    })
  );
}

export function soilTestSetupDone(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/soil-test-setup-done", body, { params: params })
  );
}

export function addSoilTestObservations(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/add-soil-test-observations", body, {
      params: params,
    })
  );
}

export function uploadResultsSoilTest(_, payload) {
  return handleRequest(
    axios.put("/marker/upload-results-soil-test-file", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    })
  );
}

export function updateResultReplicasNumber(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/update-results-replicas-number", body, {
      params: params,
    })
  );
}

export function sensibilitySetupDone(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/sensibility-setup-done", body, { params: params })
  );
}

export function addSensibilityObservations(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/add-sensibility-observations", body, {
      params: params,
    })
  );
}

export function getLastOligoFromMarkerList(_, payload) {
  return handleRequest(axios.post("/marker/get-last-oligo-list", payload));
}

export function uploadResultsSensibility(_, payload) {
  return handleRequest(
    axios.put("/marker/upload-results-sensibility-file", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    })
  );
}

export function cleanAllResultsSensibility(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/clean-all-results-sensibility", body, {
      params: params,
    })
  );
}

export function finishValidationMarker(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/finish-validation-marker", body, {
      params: params,
    })
  );
}

export function releasePrimerVersion(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/release-primer", body, { params: params })
  );
}

export function notifyMarker(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/notify-markers", body, { params: params })
  );
}

export function updateFluorophore(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/update-fluorophore", body, { params: params })
  );
}

export function addNewLaboratoryRange(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/add-laboratory-range", body, { params: params })
  );
}

export function updateCqRanges(_, { params, body }) {
  return handleRequest(
    axios.put("/marker/cq-ranges", body, { params: params })
  );
}
